import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIST_MAU_IN_NHANVAY,
  GET_NOI_DUNG_IN_NHANVAY,
} from "../actions/InNhanVay/actionTypes";
import {
  getListMauInNhanVaySuccess,
  getListMauInNhanVayFailure,
  getNoiDungInNhanVaySuccess,
  getNoiDungInNhanVayFailure,
} from "../actions/InNhanVay";
import { pushNotification } from "utils/notifications";
import InChoVayApi from "../service/inChoVayApi";

function* getListMauInNhanVay(action) {
  try {
    const response = yield call(InChoVayApi.combo, {});
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getListMauInNhanVayFailure());
      } else {
        yield put(getListMauInNhanVaySuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getListMauInNhanVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getListMauInNhanVayFailure());
  }
}
function* getNoiDungInNhanVay(action) {
  try {
    const response = yield call(InChoVayApi.getInNhanVay, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getNoiDungInNhanVayFailure());
      } else {
        yield put(getNoiDungInNhanVaySuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getNoiDungInNhanVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getNoiDungInNhanVayFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_MAU_IN_NHANVAY, getListMauInNhanVay);
  yield takeLatest(GET_NOI_DUNG_IN_NHANVAY, getNoiDungInNhanVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
